module.exports = __webpack_public_path__ + "static/media/ProfilePic.00446b09.png";